import { Box, Typography } from "@mui/material";
import theme from "../../../../../theme";
import {
  SPACING,
  BODY_SPACING,
  OBJECT_SIZE,
} from "../../../../../utils/constants/designConstants";

export const PFFContentSection = ({ section }) => {
  return (
    <Box
      sx={{
        mb: SPACING.SECTION_BOTTOM,
        transform: {
          xs: "translateX(0)",
          md: "translateX(0)",
          lg: "translateX(0)",
        },
        display: "flex",
        alignItems: "center",
        gap: 8,
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          color: "primary.brandMain",
          width: OBJECT_SIZE.CIRCLE_WIDTH,
          height: OBJECT_SIZE.CIRCLE_HEIGHT,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          flexShrink: 0,
          border: `2px solid ${theme.palette.primary.brandMain}`,
          textAlign: "center",
        }}
      >
        {section.number}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          maxWidth: 600,
        }}
      >
        <Typography
          variant="subtitle3"
          sx={{
            color: "primary.white",
            mb: 2,
          }}
        >
          {section.title} - Rating: {section.rating}/5
        </Typography>

        {section.bullets.map((bullet, bulletIndex) => (
          <Box
            key={bulletIndex}
            sx={{ display: "flex", gap: BODY_SPACING.BULLETS_GAP }}
          >
            <Typography variant="body1" sx={{ color: "primary.white" }}>
              {bullet}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
